import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import HouseAcceptanceNoticeModal from '../modals/HouseAcceptanceNoticeModal/HouseAcceptanceNoticeModal';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';
import styles from './HouseAcceptanceNotice.module.scss';

const HouseAcceptanceNotice = ({ className, btnClassName, text }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  return (
    <div className={className}>
      <Button
        onClick={showModal}
        className={cn(styles.button, btnClassName)}
        type="primary"
      >
        {text}
      </Button>
      <HouseAcceptanceNoticeModal visible={visible} onCancel={hideModal} />
    </div>
  );
};

export default HouseAcceptanceNotice;
